import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

import { SharedService } from '@services/shared.service';

import { ApiTransactionService } from '@services/api-transaction.service';
import { TransactionModel, TransactionNotesModel, TransactionPackageModel } from '@models/TransactionModel';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SessionModel } from '@shared/models/SessionModel';


@Component({
    selector: 'app-send-package-link',
    templateUrl: './send-package-link.component.html',
    styleUrls: ['./send-package-link.component.scss']
})
export class SendPackageLinkComponent implements OnInit {

    @Input() sale: TransactionPackageModel;

    givilink: string;
    giviLinkOrigin: string;

    linkCopied = false;

    transactionNote = '';

    session: SessionModel; 

    constructor(public location: Location,
        public router: Router,
        public sharedService: SharedService, 
        public apiTransactionService: ApiTransactionService) {
    }

    ngOnInit(): void {

        this.session = this.apiTransactionService.getSession();

        let codeType = 'PK';
        let urlType = 'pk';

        this.transactionNote = this.sale.transactionNotes?.note;

        const code = `${codeType}-${this.sale.id.toString().padStart(5, '0')}-${this.sale.customerOwnerId}`;
        let hash = window.btoa(code);

        // Remove the = symbol
        hash = hash.replace(/[=]/g, '');

        let text = `comercio=${this.sale.vendor?.name}`;
        // Remove the % symbol
        text = text.replace(/[%]/g, '');
        // Replace the spaces
        text = text.replace(/\s/g, '+');

        this.givilink = `${this.apiTransactionService.siteUrl}/${urlType}/${this.session?.user?.country}/${hash}?${text}`;
        this.giviLinkOrigin = this.givilink;
        this.givilink = this.giviLinkOrigin;
    }

    onCustomMessage(ev) {

        //this.givilink = `${ev}\n${this.giviLinkOrigin}`;
    }

    onCopyLink() {

        const giviLinkInput: any = document.getElementById('givi-link');

        const output: any = document.getElementById("givi-output");
        output.value = `${giviLinkInput.value}`;

        output.select();
        this.linkCopied = document.execCommand("Copy");

        setTimeout(() => { this.linkCopied = false }, 2000);

        this._saveNote();
    }


    private _saveNote() {

        if (!this.transactionNote) return;

        this.sharedService.setLoading(true);

        // Ya tiene una nota
        if (this.sale.transactionNotes?.id) {

        // Update
        this.sale.transactionNotes.note = this.transactionNote;

        this.apiTransactionService.updateTransactionPackageNote(this.sale.transactionNotes)
            .then((note) => this.sharedService.setLoading(false))
            .catch(err => this.sharedService.setLoading(false));
        }
        // No tiene nota
        else {

        // Create
        const giviNote = new TransactionNotesModel({
            transactionId: this.sale.id,
            customerOwnerId: this.sale.customerOwnerId,
            note: this.transactionNote,
            color: '#753CFD'
        });

        this.apiTransactionService.createTransactionPackageNote(giviNote)
            .then((note) => {
            this.sale.transactionNotes = note;
            this.sharedService.setLoading(false);
            })
            .catch(err => this.sharedService.setLoading(false));
        }
    }
}
